import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { Fragment } from "react";
const AnchorLink = dynamic(() => import("../../anchor/Anchor"), {
  ssr: false,
});

const MainMenu = ({ index, item }) => {
  const { locale } = useRouter();
  const isETransform = item.name.includes("e-");
  return (
    <div className={`item menu-item`}>
      <>
        <AnchorLink
          href={!item.children ? `/${item.href}` : "#"}
          className={`${item.children ? "link not-pointer" : " link"}`}
        >
          {item.name}
        </AnchorLink>
        {item.children && <i className="icon-angle-down" />}
      </>

      {item.children && (
        <ul className="menu_sub" key={index}>
          {item.children.map((child, index) => (
            <Fragment key={index}>
              {child.inHeader ? (
                <li className="menu_sub_item" key={index}>
                  {child?.children?.length > 0 ? (
                    <AnchorLink
                      //className={styles.menu_sub_link}
                      className={`${
                        item.children
                          ? "menu_sub_link not-pointer"
                          : "menu_sub_link"
                      }`}
                      href={item.children ? "#" : `${item.href}`}
                    >
                      {child.name}
                    </AnchorLink>
                  ) : (
                    <>
                      {child.href.slice(0, 4) === "http" ? (
                        <a
                          locale={locale}
                          className="menu_sub_link"
                          target="_blank"
                          href={item.href && child.href ? `${child.href}` : "#"}
                          style={{
                            fontWeight: isETransform && index < 3 && 700,
                          }}
                        >
                          {child.name}
                        </a>
                      ) : (
                        <AnchorLink
                          locale={locale}
                          className="menu_sub_link"
                          style={{
                            fontWeight: isETransform && index < 3 && 700,
                          }}
                          href={
                            item.href && child.href
                              ? `/${item.href}/${child.href}`
                              : "#"
                          }
                        >
                          {child.name}
                        </AnchorLink>
                      )}
                    </>
                  )}

                  {child.children && (
                    <ul className={" menu_child"} key={index}>
                      {child.children &&
                        child.children.map((subchild, index) => (
                          <Fragment key={index}>
                            <li className=" menu_child_item" key={index}>
                              <AnchorLink
                                locale={locale}
                                className=" menu_child_link"
                                href={`/${item.href}/${child.href}/${subchild.href}`}
                              >
                                {subchild.name}
                              </AnchorLink>
                            </li>
                          </Fragment>
                        ))}
                    </ul>
                  )}
                </li>
              ) : null}
            </Fragment>
          ))}
        </ul>
      )}
    </div>
  );
};

export default MainMenu;
